import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { db } from '@/database/client';
import { exportDatabaseBackup, importDatabaseBackup } from '../utils/backup';

export default function SettingsPage() {
  const [backupText, setBackupText] = useState('');

  useEffect(() => {
    const load = async () => {
      setBackupText(await exportDatabaseBackup());
    };
    void load();
  }, []);

  const handleExport = async () => {
    const exported = await exportDatabaseBackup();
    setBackupText(exported);
    toast.success('Backup exported');
  };

  const handleImport = async () => {
    await importDatabaseBackup(backupText);
    toast.success('Backup imported');
  };

  const handleReset = async () => {
    await db.transaction('rw', db.tables, async () => {
      await Promise.all(db.tables.map((table) => table.clear()));
    });
    toast.success('Database cleared');
  };

  return (
    <div style={{ maxWidth: 860, margin: '0 auto', display: 'grid', gap: 20 }}>
      <section
        className="card"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 12,
        }}
      >
        <div>
          <p
            style={{
              margin: 0,
              textTransform: 'uppercase',
              letterSpacing: '0.24em',
              fontSize: 12,
              opacity: 0.7,
            }}
          >
            Privacy & Backup
          </p>
          <h1 style={{ margin: '6px 0 0' }}>Your offline ledger</h1>
        </div>
        <Link
          to="/"
          className="secondary-button"
          style={{ textDecoration: 'none' }}
        >
          Back home
        </Link>
      </section>

      <section className="card">
        <h2 style={{ marginTop: 0 }}>Backup</h2>
        <textarea
          value={backupText}
          onChange={(event) => setBackupText(event.target.value)}
          rows={10}
          style={{
            width: '100%',
            borderRadius: 12,
            border: '1px solid rgba(0,0,0,0.15)',
            padding: 12,
          }}
        />
        <div
          style={{ display: 'flex', gap: 12, marginTop: 12, flexWrap: 'wrap' }}
        >
          <button
            className="primary-button"
            onClick={() => void handleExport()}
          >
            Export backup
          </button>
          <button
            className="secondary-button"
            onClick={() => void handleImport()}
          >
            Import backup
          </button>
          <button
            className="secondary-button"
            onClick={() => void handleReset()}
          >
            Clear local data
          </button>
        </div>
      </section>
    </div>
  );
}
